import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { patientApi } from "./apiClient";
import type { IVideoService } from "@medoma/models/video";
import { generateQueryString } from "./Helpers";

const jitsiInfoSchema = z.object({
  token: z.string(),
  domain: z.string(),
  room: z.string(),
});

const videoKeys = {
  all: ["video"] as const,
  info: (videoService: IVideoService) =>
    [...videoKeys.all, "info", videoService] as const,
};

export const useVideoInfo = (videoService: IVideoService) => {
  return useQuery({
    queryKey: videoKeys.info(videoService),
    queryFn: async () => {
      const path = "videocall";
      if (videoService === "Jitsi") {
        const queryParameters = generateQueryString({
          "video-service": "jitsi",
        });
        const url = `${path}${queryParameters}`;

        return {
          ...(await patientApi.post(url).json(jitsiInfoSchema)),
          videoService: "Jitsi" as const,
        };
      }

      return null;
    },
    // Default (true). Set for clarity. Since we run video in the same window in Care we need to refetch on mount.
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
